import * as React from 'react';

import { weightToPounds } from '@rematter/ui-web';
import { useAtomValue } from 'jotai';

import { $itemsInterfaceEntries, $monetaryTotals } from '../_state';
import {
  enumLineItemKind,
  NormalizedDeduction,
  NormalizedLineItem,
} from '../_types';
import { calculateWeightSummary } from '../utils/purchaseSummary';

export const useTicketSummary = () => {
  const { items, heavyWeight, lightWeight } = useAtomValue(
    $itemsInterfaceEntries,
  );
  const monetaryTotals = useAtomValue($monetaryTotals);

  const weightSummary = React.useMemo(() => {
    const heavyWeightLbs = heavyWeight ? weightToPounds(heavyWeight) : 0;
    const lightWeightLbs = lightWeight ? weightToPounds(lightWeight) : 0;

    const lineItems = items.filter(
      (e): e is NormalizedLineItem => e.kind === enumLineItemKind.LineItem,
    );
    const deductions = items.filter(
      (e): e is NormalizedDeduction => e.kind === enumLineItemKind.Deduction,
    );

    return calculateWeightSummary(
      lineItems,
      deductions,
      heavyWeightLbs,
      lightWeightLbs,
    );
  }, [items, heavyWeight, lightWeight]);

  return {
    materials: weightSummary.netWeightAfterDeductions,
    deductionsWeight: weightSummary.deductionsWeight,
    tareOnTruck: weightSummary.tareOnTruck,
    outstanding: weightSummary.outstandingNetWeight,
    deductionsTotal: monetaryTotals.deductionsTotal,
    freightTotal: monetaryTotals.freightTotal,
    purchaseTotal: monetaryTotals.purchaseTotal,
    currencyCode: monetaryTotals.currencyCode,
  };
};
